import { toast } from 'sonner';

/**
 * Transient feedback as toasts. Longer for errors so they can be read; hovering
 * a toast pauses its timer. The id is derived from the text, so the same
 * message fired twice (e.g. a failing reload) replaces itself instead of
 * stacking.
 *
 * Falsy messages are ignored, which lets callers keep "clear the error" calls
 * like notify.error(null) harmlessly. Each function is a stable module-level
 * reference, so it is safe to pass as onError/onNotice into hook dependencies.
 */
const DURATION = { success: 3500, info: 5000, warning: 6500, error: 8000 };

function show(kind, message, options) {
  if (!message) return undefined;
  const text = String(message);
  return toast[kind](text, { id: `${kind}:${text}`, duration: DURATION[kind], ...options });
}

export const notify = {
  success: (message, options) => show('success', message, options),
  info: (message, options) => show('info', message, options),
  warning: (message, options) => show('warning', message, options),
  error: (message, options) => show('error', message, options),
};
